(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function define(name, ctor) {
      if (!customElements.get(name)) customElements.define(name, ctor);
    }
    function clamp(n, lo, hi) {
      return Math.max(lo, Math.min(hi, n));
    }
    function prefersReduce() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    // A single before/after comparison with a draggable divider.
    class BaSlider extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('[data-ba-frame]');
        if (!this.frame || this._wired) return;
        this._wired = true;
        this.dragging = false;
        this.pointerId = null;
        this.beforeLabel = this.getAttribute('data-before-label') || 'Before';
        this.touchLock = null;
        this.ac = new AbortController();
        var signal = this.ac.signal;
        var opt = { signal: signal };
        // Mouse / pen go through Pointer Events.
        this.addEventListener('pointerdown', this.onDown.bind(this), opt);
        this.addEventListener('pointermove', this.onMove.bind(this), opt);
        this.addEventListener('pointerup', this.onUp.bind(this), opt);
        this.addEventListener('pointercancel', this.onUp.bind(this), opt);
        this.addEventListener('lostpointercapture', this.onUp.bind(this), opt);
        // Touch is handled explicitly with a directional lock so a horizontal
        // drag moves the divider (and we preventDefault to stop the carousel /
        // page from scrolling), while a vertical swipe still scrolls the page.
        // Touch events are implicitly captured to this element, so no scroll-snap
        // container can steal the gesture.
        this.addEventListener('touchstart', this.onTouchStart.bind(this), { signal: signal, passive: true });
        this.addEventListener('touchmove', this.onTouchMove.bind(this), { signal: signal, passive: false });
        this.addEventListener('touchend', this.onTouchEnd.bind(this), opt);
        this.addEventListener('touchcancel', this.onTouchEnd.bind(this), opt);
        this.addEventListener('keydown', this.onKey.bind(this), opt);
        this.addEventListener('dragstart', function (e) { e.preventDefault(); }, opt);
        var start = parseFloat(this.getAttribute('data-start'));
        this.setPos(isNaN(start) ? 50 : start);
      }
      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.dragging = false;
        this._wired = false;
      }
      onDown(e) {
        // Touch is handled by the touch* listeners; ignore its pointer events.
        if (e.pointerType === 'touch') return;
        // Only the primary (left) mouse button should start a drag.
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.dragging = true;
        this.pointerId = e.pointerId;
        try { this.setPointerCapture(e.pointerId); } catch (_) {}
        this.fromClientX(e.clientX);
      }
      onMove(e) {
        if (e.pointerType === 'touch') return;
        if (this.dragging) this.fromClientX(e.clientX);
      }
      onTouchStart(e) {
        if (e.touches.length !== 1) { this.touchLock = 'skip'; return; }
        var t = e.touches[0];
        this.touchStartX = t.clientX;
        this.touchStartY = t.clientY;
        this.touchLock = null;
      }
      onTouchMove(e) {
        if (this.touchLock === 'skip' || e.touches.length !== 1) return;
        var t = e.touches[0];
        if (this.touchLock === null) {
          var dx = Math.abs(t.clientX - this.touchStartX);
          var dy = Math.abs(t.clientY - this.touchStartY);
          if (dx < 6 && dy < 6) return; // wait until the gesture has a clear direction
          this.touchLock = dx > dy ? 'h' : 'v';
        }
        if (this.touchLock === 'h') {
          e.preventDefault(); // horizontal drag: move divider, don't scroll
          this.fromClientX(t.clientX);
        }
      }
      onTouchEnd() {
        this.touchLock = null;
      }
      onUp(e) {
        if (!this.dragging) return;
        this.dragging = false;
        try {
          if (e.pointerId != null && this.hasPointerCapture && this.hasPointerCapture(e.pointerId)) {
            this.releasePointerCapture(e.pointerId);
          }
        } catch (_) {}
        this.pointerId = null;
      }
      fromClientX(x) {
        var r = this.frame.getBoundingClientRect();
        if (!r.width) return;
        this.setPos(((x - r.left) / r.width) * 100);
      }
      onKey(e) {
        var step = e.shiftKey ? 10 : 2;
        var p = this.pos;
        var handled = true;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown': p -= step; break;
          case 'ArrowRight':
          case 'ArrowUp': p += step; break;
          case 'Home': p = 0; break;
          case 'End': p = 100; break;
          case 'PageDown': p -= 20; break;
          case 'PageUp': p += 20; break;
          default: handled = false;
        }
        if (handled) {
          e.preventDefault();
          this.setPos(p);
        }
      }
      setPos(p) {
        if (typeof p !== 'number' || isNaN(p)) return;
        p = clamp(p, 0, 100);
        this.pos = p;
        var rounded = Math.round(p);
        this.style.setProperty('--pos', p + '%');
        this.setAttribute('aria-valuenow', rounded);
        this.setAttribute('aria-valuetext', rounded + '% ' + this.beforeLabel + ' shown');
      }
    }
    define('ba-slider', BaSlider);

    // The carousel wrapping the comparison slides.
    class BaCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track || this._wired) return;
        this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-slide]'));
        // A single comparison needs no carousel chrome (arrows / dots).
        if (this.slides.length <= 1) return;
        this._wired = true;
        this.active = 0;
        this.ac = new AbortController();
        var opt = { signal: this.ac.signal };
        var self = this;

        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.classList.add('is-enhanced');

        if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.page(-1); }, opt);
        if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.page(1); }, opt);

        this.buildDots(opt);

        var raf = 0;
        this.track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            self.active = self.index();
            self.update();
          });
        }, opt);

        var rt = 0;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(function () { self.realign(); }, 150);
        }, opt);

        this.update();
      }
      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this._wired = false;
      }
      width() {
        return this.track.clientWidth || 1;
      }
      index() {
        return clamp(Math.round(this.track.scrollLeft / this.width()), 0, this.slides.length - 1);
      }
      page(dir) {
        this.goTo(this.active + dir);
      }
      goTo(i) {
        this.active = clamp(i, 0, this.slides.length - 1);
        this.track.scrollTo({ left: this.active * this.width(), behavior: prefersReduce() ? 'auto' : 'smooth' });
        this.update();
      }
      realign() {
        this.track.scrollTo({ left: this.active * this.width(), behavior: 'auto' });
        this.update();
      }
      buildDots(opt) {
        if (!this.dotsWrap) return;
        var self = this;
        this.dotsWrap.innerHTML = '';
        this.dotsWrap.removeAttribute('aria-hidden');
        this.dots = this.slides.map(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ba__dot';
          b.setAttribute('aria-label', 'Go to comparison ' + (i + 1));
          b.addEventListener('click', function () { self.goTo(i); }, opt);
          self.dotsWrap.appendChild(b);
          return b;
        });
      }
      update() {
        var i = this.active;
        if (this.dots) {
          this.dots.forEach(function (d, di) {
            var on = di === i;
            d.classList.toggle('is-active', on);
            if (on) d.setAttribute('aria-current', 'true');
            else d.removeAttribute('aria-current');
          });
        }
        if (this.prevBtn) this.prevBtn.disabled = i <= 0;
        if (this.nextBtn) this.nextBtn.disabled = i >= this.slides.length - 1;
      }
    }
    define('ba-carousel', BaCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-news"] && !Shopify.designMode) return;
  try {
    
  // Fire a one-shot pop/spin on the ✦ when the section scrolls into view — the
  // same celebration cart.js plays when free shipping unlocks. At rest it keeps
  // the gentle CSS twinkle. Honours reduced-motion and re-arms in the editor.
  (function () {
    function reduce() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    function pop(el) {
      if (reduce() || typeof el.animate !== 'function') return;
      el.animate(
        [
          { transform: 'scale(0.9) rotate(-120deg)', opacity: 0 },
          { transform: 'scale(1.06) rotate(8deg)', opacity: 1, offset: 0.7 },
          { transform: 'scale(1) rotate(0deg)', opacity: 1 },
        ],
        { duration: 640, easing: 'cubic-bezier(0.34, 1.4, 0.64, 1)' }
      );
    }

    var io = null;
    function observer() {
      if (io || !('IntersectionObserver' in window)) return io;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            pop(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.6 });
      return io;
    }

    function setup(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var sparks = scope.querySelectorAll('[data-fnews-spark]');
      var ob = observer();
      for (var i = 0; i < sparks.length; i++) {
        var s = sparks[i];
        if (s.dataset.sparkObserved) continue;
        s.dataset.sparkObserved = '1';
        if (ob) ob.observe(s);
        else pop(s); // no IntersectionObserver support — just celebrate once
      }
    }

    if (document.readyState !== 'loading') setup();
    else document.addEventListener('DOMContentLoaded', function () { setup(); });
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Tiny fingerprint of Soup Agency's signature scramble-text effect: on hover
  // (or keyboard focus) the credit link's letters shuffle, then resolve
  // left-to-right. Scoped to [data-scramble] only. Honours reduced motion.
  (function () {
    var UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var LOWER = 'abcdefghijklmnopqrstuvwxyz';
    var DIGITS = '0123456789';

    function randomFrom(set) {
      return set.charAt(Math.floor(Math.random() * set.length));
    }
    function randomLike(ch) {
      if (/[A-Z]/.test(ch)) return randomFrom(UPPER);
      if (/[a-z]/.test(ch)) return randomFrom(LOWER);
      if (/[0-9]/.test(ch)) return randomFrom(DIGITS);
      return ch;
    }
    // Reveal characters left-to-right as progress runs 0 -> 1; the rest shuffle.
    function scrambleFrame(target, progress) {
      var reveal = Math.floor(Math.min(1, Math.max(0, progress)) * target.length);
      var out = '';
      for (var i = 0; i < target.length; i++) {
        var ch = target.charAt(i);
        if (ch === ' ') out += ' ';
        else if (i < reveal) out += ch;
        else out += randomLike(ch);
      }
      return out;
    }
    function reduce() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function wire(link) {
      if (link.dataset.scrambleWired) return;
      link.dataset.scrambleWired = '1';
      var target = link.textContent;

      // Lock the width so shuffling glyphs never reflow the line.
      link.style.display = 'inline-block';
      link.style.whiteSpace = 'nowrap';
      var w = link.getBoundingClientRect().width;
      if (w) link.style.minWidth = Math.ceil(w) + 'px';

      var timer = null;
      function settle() {
        if (timer) { clearInterval(timer); timer = null; }
        link.textContent = target;
      }
      function run() {
        if (reduce()) return;
        if (timer) clearInterval(timer);
        var tickMs = 36;
        var totalFrames = Math.max(8, Math.round(640 / tickMs));
        var frame = 0;
        timer = window.setInterval(function () {
          frame += 1;
          var progress = frame / totalFrames;
          link.textContent = scrambleFrame(target, progress);
          if (progress >= 1) settle();
        }, tickMs);
      }

      link.addEventListener('mouseenter', run);
      link.addEventListener('focus', run);
      link.addEventListener('mouseleave', settle);
      link.addEventListener('blur', settle);
    }

    function setup(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var links = scope.querySelectorAll('[data-scramble]');
      for (var i = 0; i < links.length; i++) wire(links[i]);
    }

    if (document.readyState !== 'loading') setup();
    else document.addEventListener('DOMContentLoaded', function () { setup(); });
    document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-molecule"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function define(name, ctor) {
      if (!customElements.get(name)) customElements.define(name, ctor);
    }
    function reduce() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    class GoddessMolecule extends HTMLElement {
      connectedCallback() {
        if (this._wired) return;
        this._wired = true;
        this.zones = ['cuticle', 'cortex', 'together'];
        this.i = 0;
        this.paused = false;
        this.ac = new AbortController();
        var opt = { signal: this.ac.signal };
        var self = this;

        this.callouts = Array.prototype.slice.call(this.querySelectorAll('[data-target]'));

        this.callouts.forEach(function (c) {
          var target = c.getAttribute('data-target');
          function focusZone() { self.pause(); self.activate(target); }
          c.addEventListener('mouseenter', focusZone, opt);
          c.addEventListener('focusin', focusZone, opt);
          c.addEventListener('mouseleave', function () { self.resume(); }, opt);
          c.addEventListener('focusout', function () { self.resume(); }, opt);
        }, this);

        // Start on the first zone; auto-cycle unless disabled or reduced-motion.
        var first = this.callouts.length ? this.callouts[0].getAttribute('data-target') : 'cuticle';
        this.activate(first);
        if (this.getAttribute('data-autoplay') === 'true' && !reduce() && this.zones.length > 1) {
          this.startCycle();
          // Only cycle while the section is on-screen — no work (or battery
          // drain) while it's scrolled out of view.
          this.offscreen = true;
          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(function (entries) {
              self.offscreen = !entries[0].isIntersecting;
            }, { threshold: 0.15 });
            this.io.observe(this);
          } else {
            this.offscreen = false;
          }
        }
      }
      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
        if (this.io) { this.io.disconnect(); this.io = null; }
        this._wired = false;
      }
      activate(zone) {
        if (!zone) return;
        this.setAttribute('data-active', zone);
        var idx = this.zones.indexOf(zone);
        if (idx !== -1) this.i = idx;
      }
      startCycle() {
        var self = this;
        this.timer = window.setInterval(function () {
          if (self.paused || self.offscreen) return;
          self.i = (self.i + 1) % self.zones.length;
          self.activate(self.zones[self.i]);
        }, 3400);
      }
      pause() { this.paused = true; }
      resume() { this.paused = false; }
    }
    define('goddess-molecule', GoddessMolecule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteMenu extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.toggle = this.querySelector('[data-menu-open]');
      if (!this.dialog || !this.toggle) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.toggle.addEventListener('click', () => this.open(), { signal });
      this.querySelectorAll('[data-menu-close]').forEach((b) =>
        b.addEventListener('click', () => this.close(), { signal })
      );
      // Close when a nav link is chosen (covers same-page/hash links).
      this.querySelectorAll('.menu-dialog__link, .menu-dialog__account').forEach((a) =>
        a.addEventListener('click', () => this.close(), { signal })
      );
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); }, { signal });
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); }, { signal });
    }

    disconnectedCallback() { this.controller?.abort(); }

    open() {
      if (!this.dialog.open) {
        this.classList.remove('is-closing');
        this.dialog.showModal();
        this.toggle.setAttribute('aria-expanded', 'true');
      }
    }

    close() {
      if (!this.dialog.open || this.closing) return;
      this.toggle.setAttribute('aria-expanded', 'false');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { this.dialog.close(); return; }
      this.closing = true;
      this.classList.add('is-closing');
      let done = false;
      let timer;
      const finish = () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        this.dialog.removeEventListener('transitionend', onEnd);
        this.classList.remove('is-closing');
        this.dialog.close();
        this.closing = false;
      };
      const onEnd = (e) => { if (e.target === this.dialog && e.propertyName === 'transform') finish(); };
      timer = setTimeout(finish, 460);
      this.dialog.addEventListener('transitionend', onEnd);
    }
  }
  if (!customElements.get('site-menu')) customElements.define('site-menu', SiteMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Size each full-height hero to the viewport minus everything above it
  // (the sticky header + announcement bar). The hero's distance from the top of
  // the document equals that combined height, so we read it and expose it as a
  // CSS variable the stylesheet subtracts from 100svh.
  (function () {
    function sizeHeroes() {
      var heroes = document.querySelectorAll('.hero');
      for (var i = 0; i < heroes.length; i++) {
        var hero = heroes[i];
        var offset = hero.getBoundingClientRect().top + window.scrollY;
        hero.style.setProperty('--hero-offset', Math.max(0, Math.round(offset)) + 'px');
      }
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sizeHeroes();
      });
    }

    if (document.readyState !== 'loading') {
      schedule();
    } else {
      document.addEventListener('DOMContentLoaded', schedule);
    }
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    window.addEventListener('shopify:section:load', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      // Wire once per instance: a theme-editor disconnect/reconnect would
      // otherwise stack duplicate thumb/lightbox listeners on this element.
      if (this._wired) return;
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      if (this.slides.length === 0) return;
      this._wired = true;
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.count = this.slides.length;
      this.index = 0;
      this.fulls = this.slides.map((s) => s.dataset.full || '');
      this.alts = this.slides.map((s) => s.dataset.alt || '');
      this.lightbox = this.querySelector('[data-gallery-lightbox]');
      this.lightboxImg = this.querySelector('[data-lightbox-img]');
      this.counter = this.querySelector('[data-lightbox-counter]');

      this.classList.add('is-enhanced');

      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.select(i)));

      const main = this.querySelector('[data-gallery-main]');
      if (main) main.addEventListener('click', () => this.openLightbox());
      const zoom = this.querySelector('[data-gallery-zoom]');
      if (zoom) {
        zoom.addEventListener('click', (e) => { e.stopPropagation(); this.openLightbox(); });
      }

      if (this.lightbox) {
        const prev = this.querySelector('[data-lightbox-prev]');
        const next = this.querySelector('[data-lightbox-next]');
        const close = this.querySelector('[data-lightbox-close]');
        if (prev) prev.addEventListener('click', () => this.step(-1));
        if (next) next.addEventListener('click', () => this.step(1));
        if (close) close.addEventListener('click', () => this.lightbox.close());
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox || e.target.classList.contains('product__lightbox-stage')) {
            this.lightbox.close();
          }
        });
        this.lightbox.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
        });
      }
    }

    select(i) {
      this.index = ((i % this.count) + this.count) % this.count;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === this.index));
      this.thumbs.forEach((t, n) => {
        const on = n === this.index;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      const activeThumb = this.thumbs[this.index];
      if (activeThumb) activeThumb.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      if (this.lightbox && this.lightbox.open) this.renderLightbox();
    }

    step(d) { this.select(this.index + d); }

    openLightbox() {
      if (!this.lightbox) return;
      this.renderLightbox();
      if (!this.lightbox.open) this.lightbox.showModal();
    }

    renderLightbox() {
      if (this.lightboxImg) {
        this.lightboxImg.src = this.fulls[this.index] || '';
        this.lightboxImg.alt = this.alts[this.index] || '';
      }
      if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + this.count;
    }
  }
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
